import { ref } from "vue";
import { defineStore } from "pinia";

export const useDocumentListModalStore = defineStore("documentListModal", () => {
  const isOpen = ref(false);
  const documentIds = ref<number[]>([]);
  let onSuccess: (() => void) | null = null;

  function open(ids: number | number[], successCallback?: () => void) {
    documentIds.value = Array.isArray(ids) ? [...ids] : [ids];
    onSuccess = successCallback ?? null;
    isOpen.value = true;
  }

  function close() {
    isOpen.value = false;
    documentIds.value = [];
    onSuccess = null;
  }

  function notifySuccess() {
    onSuccess?.();
    onSuccess = null;
  }

  return { isOpen, documentIds, open, close, notifySuccess };
});
